// extracted by mini-css-extract-plugin
module.exports = {"timeBox":"ShowTime__timeBox__RSrvW"};